var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 63,
    viewBox: "0 0 57 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 24.5164C5.5 25.9864 4.16 27.2664 2.75 27.2664C1.34 27.2664 0 25.9864 0 24.5164C0 23.0464 1.34 21.7664 2.75 21.7664C4.16 21.7664 5.5 23.1064 5.5 24.5164ZM1.02 62.2764V30.3364H4.48V62.2664H1.02V62.2764Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.19 12.6163L52.8 13.2563C51.97 8.90629 50.88 5.19629 47.49 3.84629C45.51 3.01629 43.33 3.20629 41.54 4.29629C39.88 5.38629 38.53 7.17629 37.64 9.60629C36.94 11.9763 36.49 14.8563 36.49 17.9263V29.2563H50.38V32.6463H36.48V62.2763H33.09V32.6463H21.5V29.2563H33.09V17.9263C33.09 14.5363 33.54 11.2663 34.43 8.58629C35.45 5.38629 37.44 2.76629 39.81 1.35629C42.43 -0.183706 45.95 -0.433706 48.83 0.716294C53.63 2.69629 55.29 7.88629 56.19 12.6163Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIf);
export default __webpack_public_path__ + "static/media/IF.4527e2e9ae45a758ab3d83a4f80e08ad.svg";
export { ForwardRef as ReactComponent };